export const chargingStationGroupsApiErrors: Record<string, string> = {
  GROUP_NAME_UNIQUE_PER_LOCATION: 'chargingStationGroupMustBeUnique',
};
